import { Component, OnInit } from '@angular/core';
import { Toaster } from '@app/services';
import { AddOrganizationPayload, LasgroOrganization } from 'api/models';
import { OrganizationService } from 'api/services';
import CustomStore from 'devextreme/data/custom_store';
import { LocalStorage } from 'ngx-webstorage';
import Swal from 'sweetalert2';

@Component({
  selector: 'organizations',
  templateUrl: './organizations.component.html',
  styleUrls: ['./organizations.component.scss'],
})
export class OrganizationsComponent implements OnInit {
  @LocalStorage() organizationId: string;
  @LocalStorage() role: string;

  loading: boolean = false;

  dataSource: any;
  rolesData: any;
  loginAsData = ['customer', 'supplier']
  planData = ['Free', 'Gold Monthly']
  constructor(private $company: OrganizationService, private $toaster: Toaster) {}

  ngOnInit() {
    this.dataSource = new CustomStore({
      key: 'id',
      load: () => this.getCompanies(),
      insert: (values) => this.addCompany(values),
      update: (organizationId, values) => {
        return this.$company.organizationShow(organizationId).subscribe((existingItem) => {
          const updatedItem = { ...existingItem, ...values };
          return this.updateCompany(updatedItem);
        });
      },
      remove: (key) => this.deleteCompany(key),
    });
  }

  getCompanies() {
    return this.$company
      .organizationFullList()
      .toPromise()
      .then((companies: any) => companies)
      .catch((error) => {
        console.error(error);
        this.$toaster.show('error', 'Companies', 'An error occurred, please try again later.');
      });
  }

  updateCompany(data: LasgroOrganization) {
    return this.$company
      .organizationUpdate({ organizationID: data.id, payload: data })
      .toPromise()
      .then((companies: any) => {
        this.$toaster.show('success', 'Company', 'The Company was updated successfully.');
        this.dataSource.load();
      })
      .catch((error) => {
        console.error(error);
        this.$toaster.show('error', 'Companies', 'An error occurred, please try again later.');
      });
  }

  addCompany(data: LasgroOrganization) {
    return this.$company
      .organizationAdd(data as AddOrganizationPayload)
      .toPromise()
      .then((companies: any) => {
        this.$toaster.show('success', 'Company', 'The Company was added successfully.');
      })
      .catch((error) => {
        console.error(error);
        if (error?.error?.detail?.includes('Company quota exceeded')) {
          this.$toaster.show('error', 'Companies', 'Company quota exceeded.');
        } else {
          this.$toaster.show('error', 'Companies', 'An error occurred, please try again later.');
        }
      });
  }

  deleteCompany(companyId): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      Swal.fire({
        title: 'Are you sure?',
        text: `Company will be permanently removed from the system`,
        icon: 'question',
        showCancelButton: true,
        buttonsStyling: false,
        confirmButtonText: 'Confirm',
        customClass: {
          confirmButton: 'btn btn-primary mr-2',
          cancelButton: 'btn btn-danger ml-2',
        },
        confirmButtonColor: '#41b146',
        cancelButtonColor: '#c74141',
      }).then((result) => {
        if (result.value) {
          this.$company
            .organizationDelete(companyId)
            .toPromise()
            .then((Companies: any) => {
              this.$toaster.show('success', 'Company', 'The Company was removed successfully.');
              resolve();
            })
            .catch((error) => {
              console.error(error);
              this.$toaster.show('error', 'Companies', 'An error occurred, please try again later.');
              reject(error);
            });
        } else {
          resolve();
        }
      });
    });
  }

  canEdit() {
    return ['Lasgro Admin'].includes(this.role);
  }

  getExportFileName() {
    return 'ION Companies';
  }
}
